export default {
  updateData: (_this, obj) => {
    _this.$emit("update:fieldValue", {
      VerifyFail: obj.dirty && obj.invalid,
      fieldName: obj.fieldName,
      value: obj.value,
      otherValue: obj.otherValue
    });
    _this.$emit("update:fieldResult", obj);
  }
};
